// TODO this is actually Staging configuration, not Prod.
// We need to separate Staging and Prod configuration in future
// or even extract config in separate file and patch it when running CI/CD pipeline
export const environment = {
	production: true,
	basePortalUrl: 'https://marketplace2.staging.ark.wine',
	apiBaseUrl: '#{Api_BaseUrl}',
	authUrl: 'https://identity.staging.nationalstorage.com.au',
	userManagementUrl: 'https://api.staging.ark.wine/usermanagement',
	referenceDataUrl: 'https://api.staging.ark.wine/referencedata',
	facilityManagementUrl: 'https://api.staging.ark.wine/facilitymanagement',
	storageManagementUrl: 'https://api.staging.ark.wine/storagemanagement',
	billingUrl: 'https://api.staging.ark.wine/billing',
	paymentsUrl: 'https://api.staging.ark.wine/payments',
	marketplaceUrl: 'https://api.staging.ark.wine/marketplace',
	winePortalUrl: 'https://portal.staging.ark.wine',
	baseWineArkUrl: 'https://www.wineark.com.au',
	winearkTermsAndConditionsUrl: 'https://www.wineark.com.au/terms-and-conditions/',
	winearkManagedTermsUrl: 'https://www.wineark.com.au/managed-storage-agreement-terms/',
	winearkDirectDebitTermsUrl: 'https://www.wineark.com.au/direct-debit-autopay-terms/',
	winearkMarketplaceTermsUrl: 'https://www.wineark.com.au/wine-ark-marketplace-terms-and-conditions/',
	winearkInsuranceFaqUrl: 'https://www.wineark.com.au/insurance-faq/',
	winearkRateScheduleUrl: 'https://www.wineark.com.au/rates/',
	winearkPrivacyPolicyUrl: 'https://www.wineark.com.au/privacy-policy/',
	googleTagMangerId: 'GTM-KSG7ZC4',
	googleTagMangerEnv: 'env-26'.length == 0 ? undefined : 'env-26',
	googleTagMangerAuth: 'etQ-qcpXm9HKtVPyWzCuHw'.length == 0 ? undefined : 'etQ-qcpXm9HKtVPyWzCuHw',
	cloudflareSiteKey: '0x4AAAAAAAe6wpEIE5TWCd4N',
	sentryDsn: '',
	sentryEnvironmentName: '',
};
